/*
 * @Author: 侯鹏许 
 * @Date: 2019-05-31 14:40:15 
 * @Last Modified by: 侯鹏许
 * @Last Modified time: 2019-06-05 16:52:21
 */
/**
 * 常用请求
 */
import global_ from "../global.config";
import request from "@/utils/request";
import Cookies from "js-cookie";
import { MessageBox } from "mint-ui";
import util from "@/utils/utils";
import axios from "axios";

export function test() {
  console.obj(11111111);
}

/**
 * 获取验证码
 */
export function getSmsCode(mobile, prompt) {
  return new Promise(function (resolve, reject) {
    request
      .get(
        global_.API_URL, {
        action: "getVericode",
        requestParam: {
          mobile: mobile
        }
      })
      .then(function (data) {
        if (prompt) {
          MessageBox.alert(prompt)
        } else {
          MessageBox.alert("验证码已通过短信发送到您的手机，稍等一会儿哦！");
        }
        resolve(data);
      });
  });
}

/**
 * 意见反馈
 */
export function sendMessage(mobile, content, pageid) {
  return new Promise(function (resolve, reject) {
    request
      .get(
        global_.API_URL, {
        action: "activity",
        requestParam: {
          module: 'forum',
          oper: 'post',
          obj: {
            forumid: 20001,
            sectionid: 3,
            content: content,
            mobile: mobile,
            pageid: pageid
          }
        }
      })
      .then(function (data) {
        resolve(data);
      });
  });
}

/**
 * 注册中介
 * 带上线openid的中介注册链接，参数： ?pre=[上线的openid]
 * 经纪人注册接口把pre值传上来，字段是 preagentopenid
 */
export function registerAgent(agentname, mobile, idcard, pre) {
  return new Promise(function (resolve, reject) {
    let postObj = {
      "module": "yx", "oper": "apply",
      "agentname": agentname,
      "mobile": mobile,
      "idcard": idcard,
      "authtype": 1,//泛经纪人对应的是1
      "channel": "泛经纪人"
    }
    if (pre) {
      postObj.preagentopenid = pre;
    }
    request.get(
      global_.API_URL, {
      action: "dhyxcrm",
      requestParam: postObj
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}


/**
 * 获取用户中介角色信息
 */
export function getAgentInfo(searchObj) {
  return new Promise(function (resolve, reject) {
    let postObj = {
      "module": "yx", "oper": "getAgentInfo"
    }
    if (searchObj) {
      postObj = util.mixin(postObj, searchObj);
    }
    request.get(
      global_.API_URL, {
      action: "dhyxcrm",
      requestParam: postObj
    }
    ).then(function (data) {
      if (data.obj) {
        resolve(data.obj);
      } else {
        resolve(null);
      }
    })
  })
}

/**
 * 获取用户信息
 *  registRole 0未注册，1中介， 2销售，3中介&销售
 */
export function getUserInfo(openid) {
  return new Promise(function (resolve, reject) {
    if (location.href.indexOf("record/record") > -1) {
      reject();
      return;
    }
    if (openid) {
      request
        .get(global_.API_URL, {
          action: "/global/User/getUserInfo",
          requestParam: {
            openid: openid
          }
        })
        .then(function (data) {
          // 此接口有没有授权注册都会返回obj的
          resolve(data.obj);
        });
    } else {
      request
        .get(global_.API_URL, {
          action: "getUserinfo",
          requestParam: {}
        })
        .then(function (data) {
          // 此接口有没有授权注册都会返回obj的
          resolve(data.obj);
        });
    }

  });
}
/**
 * 获取用户信息 2
 *  这个接口可以是通用的获取用户、销售、经纪人的整合起来的信息接口。
 */
export function getUserInfo2(openid) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/User/getUserInfo2",
        requestParam: {
          openid: openid
        }
      })
      .then(function (data) {
        // 此接口有没有授权注册都会返回obj的
        resolve(data.obj);
      });
  });
}

export function apiRefreshWxUserInfo(openid) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "refreshWxUserInfo",
        requestParam: {
          obj: {
            openid: openid
          }
        }
      })
      .then(function (data) {
        resolve(data);
      });
  });
}

/**
 * 获取用户信息包含粉丝信息
 *  这个接口可以是通用的获取用户、销售、经纪人的整合起来的信息接口。
 */
export function getUserInfoAndFansInfo(openid) {
  return new Promise(function (resolve, reject) {

    Promise.all([getUserInfo(openid), fansInfo(openid)]).then(data => {
      let userInfo = data[0];
      let fansInfo = data[1];
      userInfo = util.filterUserInfoAndFansInfo(userInfo, fansInfo);
      resolve(userInfo);
    })
  });
}


/**
 * 获取用户完整信息
 */
export function getUserIntegralInfo() {
  return new Promise(function (resolve, reject) {
    let userinfoFromCooke = Cookies.get("userinfo");
    if (userinfoFromCooke && false) {
      // 不走缓存了
      resolve(JSON.parse(userinfoFromCooke));
    } else {
      Promise.all([getAgentInfo(), getUserInfo()]).then(function (values) {
        let agentInfo = values[0], userInfo = values[1];
        let userIntegralInfo = {
          agentInfo: agentInfo,
          userInfo: userInfo,
          isSale: false,//是否注册为销售且审核通过
          saleStatusMsg: "",//销售注册状态
          isAgent: false,//是否注册为中介且审核通过
          agentStatusMsg: "",//中介注册状态
          ui: {
            headimg: (userInfo.user && userInfo.user.headimgurl) ? userInfo.user.headimgurl : 'https://assets.wxmp.ruthus.com/rushixcx/default-head.png',//用户头像。优先次序：上传头像>微信头像
            name: (agentInfo ? agentInfo.agentname : '') || (userInfo.user ? userInfo.user.nickname : ''),//用户姓名。优先次序：注册姓名>微信昵称
          }
        }
        if (userInfo && userInfo.user && userInfo.user.cardno && userInfo.role && userInfo.role.length) {
          // 审核通过
          userIntegralInfo.isSale = true;
        } else if (userInfo && userInfo.user && userInfo.user.cardno) {
          // 请联系管理员，分配项目！
          userIntegralInfo.saleStatusMsg = "请联系管理员，分配项目！";
        }

        if (agentInfo && agentInfo.status == 0) {
          userIntegralInfo.agentStatusMsg = "审核失败";
        } else if (agentInfo && agentInfo.status == 1) {
          userIntegralInfo.agentStatusMsg = "审核中";
        } else if (agentInfo && agentInfo.status == 2) {
          // 审核通过
          userIntegralInfo.isAgent = true;
        }

        let inFifteenMinutes = new Date(
          new Date().getTime() + 5 * 60 * 1000
        );
        Cookies.set("userinfo", JSON.stringify(userIntegralInfo), {
          expires: inFifteenMinutes
        });
        resolve(userIntegralInfo);
      })
    }
  })
}

export function fansInfo(openid) {

  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/hb/HbUserAction/fansInfo",
        requestParam: {
          obj: {
            openid: openid
          }
        }
      })
      .then(function (data) {
        // 此接口有没有授权注册都会返回obj的
        resolve(data.obj);
      });
  });

}

/**
 * 更新用户信息
 */
export function updateLocalUserInfo() {
  return new Promise(function (resolve, reject) {
    Cookies.remove("userinfo");
    getUserIntegralInfo().then(function (data) {
      resolve(data);
    })
  });
}

/**
 * 获取账号下的项目
 */
export function getProjectList() {
  return new Promise(function (resolve, reject) {
    let postObj = {
      "module": "project", "oper": "list"
    }
    request.get(
      global_.API_URL, {
      action: "dhyxcrm",
      requestParam: postObj
    }
    ).then(function (data) {
      resolve(data.obj);
    })
  })
}

/**
 * 生成二维码
 */
export function downlineAgentQR() {
  return new Promise(function (resolve, reject) {
    let postObj = {
      module: "yx",
      oper: "downlineAgentQR"
    };
    request
      .get(global_.API_URL, {
        action: "dhyxcrm",
        requestParam: postObj
      })
      .then(function (data) {
        resolve(data.obj);
      });
  });
}
/**
 * base64
 * @param {*} imgUrl 
 * 返回的值 使用 data:image/png;base64,  拼接成base64
 */
export function base64(imgUrl) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/Image/base64",
        requestParam: {
          imgUrl: imgUrl
        }
      })
      .then(function (data) {
        resolve("data:image/png;base64," + data.obj);
      });
  });
}

/**
 * 获取H5页面内容
 * @param {*} id 
 * @param {*} psn 
 */
export function getPageInfo(id, psn, that) {
  let cacheKey = `pageinfo2_${id}_${psn}`
  let cacheData = util.getTimeStorage(cacheKey)
  return new Promise(function (resolve, reject) {
    if (cacheData && util.checkIsHuafa()) {
      console.log('sessionData===>', JSON.parse(cacheData))
      resolve(JSON.parse(cacheData))
    } else {
      let obj = {
        id: parseInt(id),
        psn: psn,
      };
      if (location.href.indexOf("henduoke.") > -1) {
        obj.rscuid = that.$rscuid || 'o3nM05hrQmGc8Z-ysAVjvc5QcTkk'
      }
      request
        .get(global_.API_URL, {
          action: "/hb/HbH5Action/getPageInfo",
          requestParam: {
            obj: obj
          }
        })
        .then(function (data) {
          if (data && data.obj && data.obj.PageData) {
            util.getIsInMiniProgram(that.isInMiniProgram).then(function (isInMiniProgram) {
              let pageData = JSON.parse(decodeURIComponent(data.obj.PageData.replace(/[+]/g, "%20")));
              if (pageData.Imagetext) {
                pageData.Imagetext = decodeURIComponent(pageData.Imagetext.replace(/[+]/g, "%20"));
                pageData.Imagetext = pageData.Imagetext.replace(/height:[\s]?[0-9.]*px[\s]?!important;/g, "height: auto!important;");
                // 非业务域名处理
                if (isInMiniProgram) {
                  // // 检索出所有域名
                  // let domainList = /^(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/.exec(pageData.Imagetext);
                  // console.log("domainList >>>>>>>>", domainList);
                  // // 检索出所有资源路径，例如：src="" 
                  // let localSrcList = pageData.Imagetext.match(/src="\S*"/g);
                  // console.log("localSrcList >>>>>>>>", localSrcList);
                  pageData.Imagetext = pageData.Imagetext.replace(/https:\/\/v.qq.com/g, 'https://henduoke.quanc.com.cn/vqqcom');
                  pageData.Imagetext = pageData.Imagetext.replace(/https:\/\/mp.weixin.qq.com/g, '');
                }
                pageData.Imagetext = pageData.Imagetext.replace(/width=[0-9]*[&]?(amp;)?height=[0-9]*[&]?(amp;)?/g, "");
                pageData.Imagetext = pageData.Imagetext.replace(/#wechat_redirect/g, "");
              }
              if (pageData.Extinfo) {
                pageData.Extinfo = JSON.parse(pageData.Extinfo);
              }
              // let inFifteenMinutes = new Date(
              //   new Date().getTime() + 1 * 60 * 1000
              // );
              // Cookies.set("pageinfo" + id, JSON.stringify(pageData), {
              //   expires: inFifteenMinutes
              // })
              pageData.PageUserSetting = data.obj.PageUserSetting;
              pageData.Other = {};

              Object.keys(data.obj).forEach(function (e) {
                if (e != "PageData") {
                  pageData.Other[e] = data.obj[e];
                }
              })
              if (!util.checkIsShlfsj()) {
                util.setTimeStorage(cacheKey, JSON.stringify(pageData), 1 / 48);
              }
              resolve(pageData);
            })
          } else {
            resolve(null);
          }
        });
    }
  });
}



/**
 * 名片获取pageinfo接口
 * @param {*} appid 
 */
export function cardPageInfo(appid, rscuid) {
  return new Promise(function (resolve, reject) {
    let pageinfoFromCooke = Cookies.get("cardPageInfo" + rscuid);
    if (pageinfoFromCooke) {
      resolve(JSON.parse(pageinfoFromCooke));
    } else {
      request
        .get(global_.API_URL, {
          action: "/hb/HbH5Action/cardPageInfo",
          requestParam: {
            appid: appid,
            rscuid: rscuid
          }
        })
        .then(function (data) {
          let pageData = data.obj;
          if (pageData) {
            pageData = {
              BrowserTabTitle: pageData.title,
              PageId: pageData.id,
              Pid: ''
            }

            let inFifteenMinutes = new Date(
              new Date().getTime() + 1 * 60 * 1000
            );
            Cookies.set("cardPageInfo" + rscuid, JSON.stringify(pageData), {
              expires: inFifteenMinutes
            })
            resolve(pageData);
          } else {
            reject();
          }
        });
    }
  });
}

/**
 * 更新H5页面内容
 */
export function updatePageInfo(that, content, title) {
  let postObj = {
    onshow: 0,
    templateno: 3,
    ispackmode: 0,
    isrushiauth: 2,
    showsharepage: 1,
    imagetext: content,
    title: title,
    projectname: '很多客',
    originalurl: that.pageInfo.OriginalUrl,
    isphone: 1,
    wxgps: that.pageInfo.Opengps || '',
    isconsult: that.pageInfo.Isconsult || '',
    formexturl: that.pageInfo.Formexturl || '',
    formname: that.pageInfo.Formname || '',
    wxsmallpic: that.pageInfo.WxShare && that.pageInfo.WxShare.FilePath,
    wxtitle: that.pageInfo.WxShare && that.pageInfo.WxShare.Title,
    wxdesc: that.pageInfo.WxShare && that.pageInfo.WxShare.Description,
    appid: that.hdkUserInfo.AppGzh.GzhAppid,
    projectid: '很多客',
    tags: '',
    // contenttags: '',
    // channeltags: '',
    id: parseInt(that.pageInfo.PageId),
    ver: that.pageInfo.Ver,

    // 以下为之前updagepageinfo没有的参数
    actheadimg: that.hdkUserInfo.Ui.HeadImg,
    actname: that.pageInfo.Actname,
    actuuid: that.pageInfo.Actuuid,
    industryid: that.hdkUserInfo.AppGzh.GzhIndustryid,
    // can_open: that.pageInfo.Onshow,
    pid: '0',

  }
  return new Promise(function (resolve, reject) {
    request
      .post2(global_.API_URL, {
        j: JSON.stringify({
          openid: that.$openid || '',
          passport: that.$passport || '',
          vericode: '',
          url: location.href,
          action: '/hb/HbH5Action/updatePageInfo',
          requestParam: {
            obj: postObj
          }
        })
      })
      .then(function (data) {
        console.log("更新文章》》》》》》》》》》》》》》", data)
        resolve(data);
      });
  });
}


/**
 * 检查页面是否有自行动 如是
 * @param {*} id 
 */
export function checkPageSelf(id) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/sales/pageselfconfig/checkPageSelf",
        requestParam: {
          obj: {
            pageid: parseInt(id)
          }
        }
      })
      .then(function (data) {
        if (data.obj && (data.obj == "1" || data.obj == 1)) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
  })
}
export function getPageSelfConfig(id) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/sales/pageselfconfig/getPageSelfConfig",
        requestParam: {
          obj: {
            pageid: parseInt(id)
          }
        }
      })
      .then(function (resp) {
        if (resp && resp.code === 0 && resp.obj && typeof (resp.obj) === 'object') {
          resolve(true);
        } else {
          resolve(false);
        }
      });
  })
}


/**
 * 检查页面是否有自行动 很多客
 * @param {*} id 页面id
 */
export function checkPageSelfByHDK(id) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/sales/pageselfconfig/checkPageSelfByHDK",
        requestParam: {
          obj: {
            pageid: parseInt(id)
          }
        }
      })
      .then(function (data) {
        if (data.obj && (data.obj == "1" || data.obj == 1)) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
  })
}


/**
 * 上报设备
 * act=mt,  增加上报一个参数 rsh5env：gzh公众号，miniprogram小程序
 * @param {*} obj 
 */
export function actMt(that) {
  return new Promise(function (resolve, reject) {
    let postObj = {
      info: util.clientInfo,
      pageid: that.pageInfo && that.pageInfo.PageId || '',
      refereeopenid: that.$refereeopenid,
      model: window.starfish.uaDevice.model,
      vendor: window.starfish.uaDevice.vendor,
      type: window.starfish.uaDevice.type,
      openid: that.$openid,
      rsh5env: that.isInMiniProgram && 'miniprogram' || 'gzh',
    };
    if (that.$rscuid) {
      postObj.rscuid = that.$rscuid;
    }
    request.post2(global_.API_URL_H5COUNT + "?act=mt", postObj).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 用户事件：在线浏览时长
 * @param {} obj 
 */
export function actIp(that, obj) {
  return new Promise(function (resolve, reject) {
    if (that.$rscuid) {
      obj.rscuid = that.$rscuid;
    }
    request.post2(global_.API_URL_H5COUNT + "?act=ip", obj).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 用户事件：统计子页面
 * @param {} obj 
 */
export function actPageNo(that, obj) {
  return new Promise(function (resolve, reject) {
    request.post2(global_.API_URL_H5COUNT + "?act=pageno", obj).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 用户事件：分享
 * @param {*} obj 
 */
export function actShare(that) {
  return new Promise(function (resolve, reject) {
    let postObj = {
      openid: that.$openid,
      pageid: that.$pageid,
      psn: that.$psn,
      refereeopenid: that.$refereeopenid,
    };
    if (that.$rscuid) {
      postObj.rscuid = that.$rscuid;
    }
    request.post2(global_.API_URL_H5COUNT + "?act=share", postObj).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 用户事件：各种点击
 * @param {*} obj 从this.enumUserEvent枚举获取
 *    atype: type,
        pageid: myPageData.PageId,
        openid: myTemp.openid,
        refereeopenid: myTemp.refereeopenid
 */
export function actAdv(that, userEvent) {
  return new Promise(function (resolve, reject) {
    let postObj = {
      atype: userEvent,
      pageid: that.$pageid,
      psn: that.$psn,
      openid: that.$openid,
      refereeopenid: that.$refereeopenid,
    }
    if (that.$rscuid) {
      postObj.rscuid = that.$rscuid;
    }
    request.post2(global_.API_URL_H5COUNT + "?act=adv", postObj).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 留电
 * @param {} that 
 * 电话
 */
export function actEntry(that, strPhone, purpose, nickname, headimg, country, province, city) {
  return new Promise(function (resolve, reject) {

    let postObj = {
      pageid: that.$pageid,
      psn: that.$psn,
      channelid: 0,
      refereeopenid: that.$refereeopenid,
      openid: that.$openid,
      purpose: purpose,//2 光速登录留电
    }
    if (strPhone) {
      postObj.phone = strPhone;
    }
    if (nickname) {
      postObj.nickname = decodeURIComponent(nickname);
    }
    if (headimg) {
      postObj.headimg = decodeURIComponent(headimg);
    }
    if (country) {
      postObj.country = decodeURIComponent(country);
    }
    if (province) {
      postObj.province = decodeURIComponent(province);
    }
    if (city) {
      postObj.city = decodeURIComponent(city);
    }

    request.post2(global_.API_URL_H5COUNT + "?act=entry", postObj).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 根据Unionid获取很多客小程序的用户信息
 */
export function findUserByUnionid(gzhAppid, unionid) {
  return new Promise(function (resolve, reject) {
    request.get2(global_.API_URL_HDK + "open/findUserByUnionid", {
      gzhAppid: gzhAppid,
      unionid: unionid
    }).then(function (res) {
      if (res.code == 200) {
        resolve(util.formatHdkUserInfo(res.data));
      } else {
        resolve({});
      }
    })
  })
}

/**
 * 根据Id获取很多客小程序的用户信息
 */
export function findUserById(uid) {
  return new Promise(function (resolve, reject) {
    request.get2(global_.API_URL_HDK + "user/info/" + uid, {
    }).then(function (res) {
      if (res.code == 200) {
        resolve(util.formatHdkUserInfo(res.data));
      } else {
        resolve({});
      }
    })
  })
}

/**
 * 添加名片到通讯录（名片上的信息发短信）
 */
export function addToContacts(cuid, mobile, vercode) {
  return new Promise(function (resolve, reject) {
    request.post2(global_.API_URL_HDK + "open/usercard/addToContacts", {
      cuid: cuid,
      mobile: mobile,
      vercode: vercode
    }).then(function (res) {
      resolve();
    })
  })
}

/**
 * 
小程序发送短信验证码
 */
export function hdkVercode(mobile) {
  return new Promise(function (resolve, reject) {
    request.post2(global_.API_URL_HDK + "vercode", {
      mobile: mobile
    }).then(function (res) {
      if (res.code == 200) {
        resolve();
      } else {
        reject();
      }
    })
  })
}

/**
 * 生成小程序码
 * 所有生成的码都应该是名片人的，除非自己点了切换
 * @param {} that 
 * @param {*} page 页面路径
 * @param {*} pageParam 页面参数对象
 */
export function wxAcode(that, page, pageParam) {
  let postObj = {
    uid: that.cardInfo.User.Id,
    page: page,
    scene: JSON.stringify({
      pid: that.cardInfo.AppGzh.Id,
      fuid: that.cardInfo.User.Id,
      ouid: that.cardInfo.User.Id,
      cuid: that.cardInfo.User.Id,
      /**
       *  {
        type: 'vcard',
        url: encodeURIComponent(`https://henduoke.quanc.com.cn/h5/vcard?refereeopenid=${openid}&rscuid=${openid}`),
      }
       */
      pageParam: pageParam || null
    })
  }
  return new Promise(function (resolve, reject) {
    request.post2(global_.API_URL_HDK + "open/wx/acode", postObj).then(function (res) {
      resolve(res.data);
    })
  })
}

/**
 * 关注首推
 */
export function limitWxQRCodeWithCallbackUrl(appid, respText, qrkey, callbackurl) {
  /**
     * https://xxx.ttrushi.com/qc-webapp/wxapi.do?j={"action":"/global/Qrcode/limitWxQRCodeWithCallbackUrl",
     * requestParam:{"appid":"xxxxx", "callbackurl":"",
     * "respText":"您的名片文章《文章标题》已生成，<a href=\"%s\">点击分享到朋友圈</a >","qrkey":"hdk"}}
     */
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/Qrcode/limitWxQRCodeWithCallbackUrl",
        requestParam: {
          appid: appid || "",
          respText: respText,
          qrkey: qrkey || "hdk",
          callbackurl: callbackurl || ""
        }
      })
      .then(function (data) {
        resolve(data.obj)
      });
  })
}

/**
 * 很多客
 * 名片里的内容列表：
 * 名片里的推荐项目：
 * orderMode 1 我相关内容  2 推荐项目
 */
export function listPageInfoWithChannel(that, orderMode, offset, size, addParam) {
  let postObj = {
    "action": "/hb/HbH5Action/listPageInfoWithChannel",
    "requestParam": {
      "obj": {
        "isdelete": 0,
        "ispackmode": 0,
        "city": that.cardInfo.User.City,
        "industryid": that.cardInfo.AppGzh.GzhIndustryid,
        "appid": that.cardInfo.AppGzh.GzhAppid,
        orderMode: orderMode,//1 我相关内容  2 推荐项目
        userGzhOpenid: that.$rscuid,//名片人的公众号openid
      },
      "offset": offset || 0,
      "size": size || 10
    }
  }
  if (orderMode == 1) {
    postObj.requestParam.obj.ownerUuid = that.cardInfo.User.Id;
  }
  if (addParam) {
    let tmpObj = postObj.requestParam.obj;
    tmpObj = util.mixin(tmpObj, addParam);
    postObj.requestParam.obj = tmpObj;
  }
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, postObj)
      .then(function (data) {
        resolve(data.obj)
      });
  })
}
/**
 * 在线售楼中心
 * 2. 前端，通过getPageinfo接口取extinfo，然后请求各部分的内容列表接口：
{"openid":"","passport":"","vericode":"",
"action":"/hb/HbH5Action/listPageInfoWithChannel",
"requestParam":{
"obj":{"isdelete":0,"ispackmode":0, "rschannel":"extinfo字段里的content_channel_tags", "tagids":"extinfo->content_pagetags->pagetags"},
"offset":0,"size":25}}
 */
export function listPageInfoWithChannel2(rschannel, tagids, offset, size, addParam) {
  let cacheKey = `t9_page_init2_${rschannel}_${tagids}`
  let postObj = {
    "action": "/hb/HbH5Action/displayPages",
    "requestParam": {
      "obj": {
        "isdelete": 0,
        "ispackmode": 0,
        rschannel: rschannel,
        tagids: tagids
      },
      "offset": offset || 0,
      "size": size || 1000
    }
  }
  if (addParam) {
    let tmpObj = postObj.requestParam.obj;
    tmpObj = util.mixin(tmpObj, addParam);
    postObj.requestParam.obj = tmpObj;
  }
  return new Promise(function (resolve, reject) {
    let cacheData = util.getTimeStorage(cacheKey)
    if (cacheData && util.checkIsHuafa()) {
      try {
        let data = JSON.parse(cacheData)
        if (data && data.total > 0) {
          console.log('sessionData===>', data)
          resolve(data)
        } else {
          request.get(global_.API_URL, postObj).then(function (data) {
            util.setTimeStorage(cacheKey, JSON.stringify(data.obj), 1 / 48);
            resolve(data.obj)
          });
        }
      } catch (err) {
        request.get(global_.API_URL, postObj).then(function (data) {
          util.setTimeStorage(cacheKey, JSON.stringify(data.obj), 1 / 48);
          resolve(data.obj)
        });
      }
    } else {
      request.get(global_.API_URL, postObj).then(function (data) {
        util.setTimeStorage(cacheKey, JSON.stringify(data.obj), 1 / 48);
        resolve(data.obj)
      });
    }
  })
}
export function listPageInfoWithChannel3(pid, tagids, offset, size, addParam) {
  let postObj = {
    "action": "/hb/HbH5Action/listPageInfoWithChannel",
    "requestParam": {
      "obj": {
        "isdelete": 0,
        "ispackmode": 0,
        pid: pid,
        tagids: tagids
      },
      "offset": offset || 0,
      "size": size || 1000
    }
  }
  if (addParam) {
    let tmpObj = postObj.requestParam.obj;
    tmpObj = util.mixin(tmpObj, addParam);
    postObj.requestParam.obj = tmpObj;
  }
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, postObj)
      .then(function (data) {
        resolve(data.obj)
      });
  })
}
/**
 * 获取阿里云签名
 */
export function aliyunActionSts() {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/aliyun/AliyunAction/sts",
        requestParam: {
        }
      })
      .then(function (res) {
        resolve(res);
      });
  })
}


/**
 * 获取存图背景图列表
 * 公众号id
 * // https://hdk.rstthd.com/api/v1/cfg/smpicmaterials?offset=0&size=100&gzhid=63f8192cf1dd4f92b6dc5f6cc1f54563
 */
export function cfgSmpicmaterials(gzhid, companyid) {
  return new Promise(function (resolve, reject) {
    request.get2(global_.API_URL_HDK + "cfg/smpicmaterials", {
      offset: 0,
      size: 100,
      gzhid: gzhid,
      companyid: companyid,
    }).then(function (res) {
      resolve(res.data);
    })
  })
}

export function openSmpicmaterials(gzhid, companyid) {
  return new Promise(function (resolve, reject) {
    request.get2(global_.API_URL_HDK + "open/smpicmaterials", {
      offset: 0,
      size: 100,
      gzhid: gzhid,
      companyid: companyid,
    }).then(function (res) {
      resolve(res.data);
    })
  })
}


/**
 * 获取分享后页面
 * @param {*} 页面id
 */
export function sharePageInfo(pageid) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/hb/HbSharePageAction/sharePageInfo",
        requestParam: {
          obj: {
            pageid: parseInt(pageid)
          }
        }
      })
      .then(function (data) {
        if (data.obj) {
          resolve(data.obj);
        } else {
          reject();
        }
      });
  });
}



/**
 * 注册信息补全通知
 */
export function registerNotify(that) {
  return new Promise(function (resolve, reject) {
    request.post2(global_.API_URL_SL + "register/notify", {
      agentUnionid: that.cardInfo.Wxuser.Unionid,
      customerUnionid: that.userInfo.user.unionid,
      gzhid: that.cardInfo.AppGzh.Id
    }).then(function (res) {
      resolve();
    })
  })
}


/**
 * 很多宝 获取页面上方的接口，里面也会返回你要的id
 * 
 * return
 * id 需要跳转的id
 * pid 父级id
 * type 标签类别：1内容标签，2渠道标签
 * tabvalue 公众号名字
 * mark 公众号简介
 * createtime
 * qrcode 公众号二维码
 * icon 公众号图标
 */
export function getChannelInfoByPageId(pageId) {
  return new Promise(function (resolve, reject) {
    let postObj = {
      pageid: parseInt(pageId)
    }
    request.get(
      global_.API_URL, {
      action: "/ct/CategoryTabAction/getChannelInfoByPageId",
      requestParam: postObj
    }
    ).then(function (data) {
      if (data.obj) {
        resolve(data.obj);
      } else {
        resolve(null);
      }
    })
  })
}


/**
 * 更新用户页面配置
 * cardhidden 1 隐藏  0展示
 */
export function updatePageUserSetting(that, cardhidden) {
  let postObj = {
    pageid: that.$pageid,
    openid: that.$openid,
    cardhidden: cardhidden
  }
  return new Promise(function (resolve, reject) {
    request
      .post2(global_.API_URL, {
        j: JSON.stringify({
          openid: that.$openid || '',
          passport: that.$passport || '',
          vericode: '',
          url: location.href,
          action: '/hb/HbH5Action/updatePageUserSetting',
          requestParam: {
            obj: postObj
          }
        })
      })
      .then(function (data) {
        resolve(data);
      });
  });
}


/**
 * 评论
 */
export function commentSave(pageid, strTxt) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/Comment/save",
        requestParam: {
          obj: {
            pageid: pageid,
            content: strTxt
          }
        }
      })
      .then(function (data) {
        resolve(data);
      });

  });
}

/**
 * 获取所有评论
 */
export function getCommentList(pageid) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/Comment/getCommentList",
        requestParam: {
          obj: {
            "pageid": pageid,
          },
          "offset": 0,
          "size": 1000
        }
      })
      .then(function (data) {
        resolve(data);
      });

  });
}


/**
 * 点赞
 */
export function doLikeComment(id, islike) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/Comment/doLikeComment",
        requestParam: {
          id: parseInt(id),
          islike: islike
        }
      })
      .then(function (data) {
        resolve(data);
      });

  });
}


/**
 * 删除
 */
export function deleteComment(id) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/global/Comment/delete",
        requestParam: {
          isdelete: 1,
          id: parseInt(id),
          ispc: 0
        }
      })
      .then(function (data) {
        resolve(data);
      });

  });
}

/**
 * 获取上级粉丝openid
 */
export function getUserUpFansPhone(that) {
  return new Promise(function (resolve, reject) {
    // that.receiveSpreadInfo.refereeopenid
    request.get(
      global_.API_URL, {
      action: "/hb/HbH5Action/getUserUpFans",
      requestParam: {
        "pageid": parseInt(that.pageInfo.PageId),
        "refereeopenid": that.$openid
      }
    }
    ).then(function (data) {
      if (data.obj)
        resolve(data.obj);
      else
        resolve(null);
    })
  })
}
/**
 * 获取注册用户电话
 */
export function getRegistUserMobile(openid) {
  return new Promise(function (resolve, reject) {

    request.get(
      global_.API_URL, {
      action: "/global/User/getRegistUserMobile",
      requestParam: {
        "openid": openid
      }
    }
    ).then(function (data) {
      if (data.obj)
        resolve(data.obj);
      else
        resolve(null);
    })
  })
}

// 1、获取二维码的接口(GET)：
export function getHDBWxAppQRCode(gzhId, openid) {
  return new Promise(function (resolve, reject) {
    request
      .get2(global_.API_URL_HDB + "getHDBWxAppQRCode", {
        wxPageUrl: `http://henduobao.quanc.com.cn/act/hdbplatform/codeInfo?id=${gzhId}`,
        wxAppId: gzhId,
        openid: openid
      })
      .then(function (res) {
        resolve(res);
      });
  })
}

// 2、订阅接口(POST)：
export function subscribe(openid, wxAppId) {
  return new Promise(function (resolve, reject) {
    let postObj = {
      Openid: openid,
      WxAppId: wxAppId
    };
    request.post(global_.API_URL_HDB + "subscribe", postObj).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 获取全民营销神码图接口
 */
export function getSmPicByTagAndQrtype(channeltags) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/smpic/SMPicAction/getSmPicByTagAndQrtype",
        requestParam: {
          channeltags: channeltags,
          qrtype: 2
        }
      })
      .then(function (data) {
        resolve(data);
      });
  });
}

/**
 * 获取全民营销神码图接口
 */
export function createUserPic(pic_id, content) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "/smpic/SMPicAction/createUserPic",
        requestParam: {
          "obj": {
            "pic_id": pic_id,
            "content": content
          }
        }
      })
      .then(function (data) {
        resolve(data);
      });
  });
}

/**
 * 获取本在线售楼中心销售员列表 按项目区分
 */
export function counselorList(projectid, offset, size) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "dhyxcrm",
        requestParam: {
          "module": "yx", "oper": "counselorList",
          "projectid": projectid,
          "offset": offset || 0,
          "size": size || 1000
        }
      })
      .then(function (data) {
        resolve(data);
      });
  });
}

/**
 * 获取h5浏览历史
 */
export function listPageBrowserDetails(pageid, offset, size) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      // action: "/hb/HbH5Action/listPageBrowserDetails",
      action: "/hb/HbH5Action/listPageBrowserUsers",
      "requestParam": {
        "obj": { "pageid": pageid, "order": 1 },
        "offset": (offset ? offset : 0),
        "size": (size ? size : 10)
      }
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 获取全部楼盘信息
 */
export function listPageByPageExtTags(pageids, keyword, offset, size, stickpageid) {
  let cacheKey = `t9_page_projectlist2_${pageids}`
  let cacheData = util.getTimeStorage(cacheKey)
  return new Promise(function (resolve, reject) {
    if (cacheData && util.checkIsHuafa() && !keyword && offset == 0) {
      console.log('sessionData===>', JSON.parse(cacheData))
      resolve(JSON.parse(cacheData))
    } else {
      request.get(
        global_.API_URL, {
        action: "/hb/HbH5Action/listPageByPageExtTags",
        "requestParam": {
          "stickpageid": stickpageid,
          "pageids": pageids,
          "search": keyword,
          "offset": (offset ? offset : 0),
          "size": (size ? size : 10)
        }
      }
      ).then(function (data) {
        if (!keyword && offset == 0) {
          util.setTimeStorage(cacheKey, JSON.stringify(data), 1 / 48);
        }
        resolve(data);
      })
    }
  })
}

/**
 * 在线售楼中心，获取上级销售(电话)
 */
export function getReferSaler(refereeopenid, pageid) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/hb/HbH5Action/getReferSaler",
      "requestParam": { "refereeopenid": refereeopenid, "pageid": pageid }
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 在线售楼中心，获取销售列表
 */
export function getProjectReferSalers(projectid, offset, size) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/hb/HbH5Action/getProjectReferSalers",
      "requestParam": {
        "projectid": projectid,
        "offset": offset || 0,
        "size": size || 1000
      }
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}


/**
 * 在线售楼中心，根据IP获取城市
 */
export function getAreaByIp() {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL_GETIP, {}
    ).then(function (data) {
      resolve(data);
    })
  })
}
/**
 * 在线售楼中心绑定小程序信息
 * @param {*} obj 
 */
export function bindRsGzhinfo(obj) {
  return new Promise(function (resolve, reject) {
    request.post2("https://wxmp.ruthus.com/api/v1/open/bindRsGzhinfo", obj).then(function (res) {
      resolve(res);
    })
  })
}

/**
 * 获取华发在线售楼中心配置
 */
export function getSalerBuildingConfig() {
  return new Promise(function (resolve, reject) {
    let hfConfigData = util.getTimeStorage('huafa_city_config2')
    if (hfConfigData && util.checkIsHuafa()) {
      console.log('hfConfigData==>', hfConfigData)
      resolve(hfConfigData);
      // resolve(JSON.parse(hfConfigData));
    } else {
      let url = ''
      if (util.checkIsHuafa()) {
        url = global_.API_URL
      } else {
        url = 'http://qmyx.rushiai.com/qc-webapp/wxapi.do'
      }
      request.get(
        url, {
        action: "/hf/PurchasingPlanAction/getSalerBuildingConfig",
        "requestParam": {}
      }
      ).then(function (data) {
        util.setTimeStorage('huafa_city_config2', data, 1 / 48)
        resolve(data);
      })
    }
  })
}

/**
 * 获取在线售楼中心配置
 */
export function guideConfig(id) {
  return new Promise(function (resolve, reject) {
    // let hfConfigData = util.getTimeStorage('huafa_city_config2')
    // if (hfConfigData && util.checkIsHuafa()) {
    //   console.log('hfConfigData==>', hfConfigData)
    //   resolve(hfConfigData);
    //   // resolve(JSON.parse(hfConfigData));
    // } else {
    request.get(
      global_.API_URL, {
      action: "/hb/BuildingSalesCenterAction/guideConfig",
      "requestParam": {
        id: id
      }
    }).then(function (data) {
      // util.setTimeStorage('huafa_city_config2', data, 1 / 48)
      resolve(data);
    })
    // }
  })
}

//预约看房 在线预约
export function subPopupInfo(name, mobile, time, projectId, pageId, psn, notifyMobile) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "dhyxcrm",
        requestParam: {
          module: "crmsaleruser",
          oper: "saveAppointment",
          notifyMobile: notifyMobile,
          obj: {
            name: name,
            mobile: mobile,
            appointmenttime: time,
            projectid: Number(projectId),
            pageid: Number(pageId),
            psn: psn
          }
        }
      })
      .then(function (data) {
        resolve(data);
      });
  });
}

//华发楼盘动态
export function getBuildingNews(pageId, state) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/hb/HbH5Action/getBuildingNews",
      "requestParam": {
        "pageId": Number(pageId),
        "state": Number(state),
        "order": "pushTime"
      }
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}

//是否订阅楼盘 hb/HbH5Action/getSubscribeUserInfo
export function getSubscribeUserInfo(pageId) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/hb/HbH5Action/getSubscribeUserInfo",
      "requestParam": {
        "pageId": Number(pageId),
      }
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}

/**
 * 华发电子名片的推荐楼盘
 */
export function displaySalerProjectPages(openid) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/hb/HbH5Action/displaySalerProjectPages",
      requestParam: {
        saleropenid: openid
      }
    }
    ).then(function (data) {
      if (data.obj)
        resolve(data.obj);
      else
        resolve(null);
    })
  })
}

//订阅楼盘/hb/HbH5Action/subscribeBuildingNews
export function subscribeBuildingNews(pageId, mobile) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/hb/HbH5Action/subscribeBuildingNews",
      "requestParam": {
        "pageId": Number(pageId),
        "mobile": Number(mobile)
      }
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}
//取消订阅/hb/HbH5Action/cancelSubscribeBuildingNews
export function cancelSubscribeBuildingNews(pageId) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/hb/HbH5Action/cancelSubscribeBuildingNews",
      "requestParam": {
        "pageId": Number(pageId)
      }
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}
/**
 * 华发广告数据
 */
export function adInfo(id) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/hb/AdAction/info",
      requestParam: {
        obj: {
          id: parseInt(id)
        }
      }
    }
    ).then(function (data) {
      if (data.obj)
        resolve(data.obj);
      else
        resolve(null);
    })
  })
}

/**
 * 华发判断是否销售
 */
export function checkIsYxUser(url) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url,
      withCredentials: true
    })
      .then(res => {
        resolve(res);
      })
      .catch(function (error) {
      });
  });
}


/**
 * 获取项目默认接待的接口是 测试pid 61
 * obj 内容
 * saleropenid: "omAuCwwHceKeZ3DOtGFwrW3FpVFg"
projectid: 61
isvalid: 1
projectname: "佘山项目"
mobile: "13512345678"
roleid: 2011
reception: 1
appid: "wx01f0b018d4951434"
createtime: 1509418310000
name: "冯伟"
id: 493
 */
export function getReceptionByProject(projectid) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "dhyxcrm",
        requestParam: {
          "module": "projectsaler", "oper": "getReceptionByProject",
          "projectid": projectid
        }
      })
      .then(function (data) {
        resolve(data);
      });
  });
}



/**
 * ********************************** 聊天相关接口 开始 ****************************************
 */
/**
 * 获取聊天token
 */
export function chatGetToken() {
  return new Promise((resolve, reject) => {
    if (Cookies.get("yqrsmake_chattoken")) {
      checkChatToken();
      resolve();
    } else {
      request
        .get(global_.API_URL, {
          action: "/global/User/yqChatToken",
          requestParam: {
            openid: myVue.$openid,
            passport: myVue.$passport,
            uid: myVue.$openid
          }
        }).then(response => {
          if (response.obj) {
            let access_token = response.obj.access_token;
            let overdueTime = new Date(new Date().getTime() + 90 * 60 * 1000);
            //缓存一个半小时的token
            Cookies.set("yqrsmake_chattoken", access_token, {
              expires: overdueTime
            });
            checkChatToken();
            resolve();
          }
        });
    }
  })

}
let checkChatTokenInterval = null;
function checkChatToken() {
  if (checkChatTokenInterval) {
    clearInterval(checkChatTokenInterval);
  }
  checkChatTokenInterval = setInterval(() => {
    if (!Cookies.get("yqrsmake_chattoken")) {
      console.log(new Date() + "检测ChatToken是否过期:过期");
      chatGetToken();
    } else {
      console.log(new Date() + "检测ChatToken是否过期:没过期");
    }
  }, 1000 * 60);
}

/**
 * 获取未读消息
 */
export function chatGetUnreadMsg() {
  return new Promise((resolve, reject) => {
    chatGetToken().then(() => {
      request
        .get(`${global_.API_CHAT}/api/getunreadmsg`, {
          uuid: myVue.$openid
        }).then(data => {
          // console.log("未读消息", data);
          if (data.Data) {
            resolve(data.Data);
          } else {
            resolve(null);
          }
        })
    })
  });
}


/**
 * 获取对话列表
 * @param {*} chatList 
 * appid: "smallappfw"
headimg: "http://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eopCThtxvXp8fpuaH7H2Reyxo25x3Ria95kJZssmiaOqXH1p15IicC1AQ9nIMKpaFIBlKvuxCKyFv7YA/132"
latestmsg: "11"
latesttime: "2020-04-07 10:32:11"
markname: ""
name: ""
nickname: "Aragorn"
roomid: "24d8fe9f7f9f472b9b96362ff48fdae9"
roomname: "Aragorn&May"
uuid: "ou0QXxD1X1fENyHSAz_jwDB_6sY4"
 */
export function chatGetUserChatList(chatList) {
  return new Promise((resolve, reject) => {
    if (chatList) {
      resolve(chatList);
    } else {
      chatGetToken().then(() => {
        request
          .get(`${global_.API_CHAT}/api/getuserchatlist`, {
            uuid: myVue.$openid
          }).then(data => {
            // console.log("对话列表", data);
            if (data.Data) {
              resolve(data.Data);
            } else {
              resolve(null);
            }
          })
      })
    }
  });
}
/**
 * ********************************** 聊天相关接口 结束 ****************************************
 */


//华发找房标签
export function tagList(citytagid) {
  let param = {
    "offset": 0,
    "pageSize": 1000
  }
  if (citytagid) {
    param.citytagid = citytagid
  }
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/house/HouseAction/tagList",
      "requestParam": param
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}


/**
 * 找房
 */
// export function searchBuilding(tagids, citytagid, params, offset, size) {
export function searchBuilding(priceTagIds, houseTypeTagIds, cityTagIds, districtTagIds, purposeTagIds, areaTagIds, otherTagIds, params, offset, size) {
  return new Promise(function (resolve, reject) {
    request.get(
      global_.API_URL, {
      action: "/house/HouseAction/searchBuilding",
      "requestParam": {
        // "tagids": tagids,
        // "citytagid": citytagid,
        priceTagIds: priceTagIds,
        houseTypeTagIds: houseTypeTagIds,
        cityTagIds: cityTagIds,
        districtTagIds: districtTagIds,
        purposeTagIds: purposeTagIds,
        areaTagIds: areaTagIds,
        otherTagIds: otherTagIds,
        "obj": params,
        "offset": (offset ? offset : 0),
        "size": (size ? size : 10)
      }
    }
    ).then(function (data) {
      resolve(data);
    })
  })
}

//获取有权限的项目
export function listAssignedProjects(openid) {
  return new Promise(function (resolve, reject) {
    request
      .get(global_.API_URL, {
        action: "dhyxcrm",
        requestParam: {
          "module": "yx", "oper": "listAssignedProjects",
          "saleropenid": openid
        }
      })
      .then(function (data) {
        resolve(data);
      });
  });
}
